import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";
import {
  AddNewNumberRequest,
  AddNewNumberResponse,
  DeleteUnansweredHandlingNumberRes,
  DeleteUnansweredHandlingNumberQuery,
} from "../../types";

export const settingsApi = createApi({
  reducerPath: "settingsApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    addNewNumberUnanswered: builder.mutation<
      AddNewNumberResponse,
      AddNewNumberRequest
    >({
      query: (body) => ({
        url: "/settings/my-number",
        method: "POST",
        body,
      }),
    }),

    deleteUnansweredHandlingNumber: builder.mutation<
      DeleteUnansweredHandlingNumberRes,
      DeleteUnansweredHandlingNumberQuery
    >({
      query: ({ id }) => ({
        url: `/settings/my-number/${id}`,
        method: "DELETE",
      }),
    }),

    getAssignedAddons: builder.query<any, void>({
      query: () => ({
        url: "/addons/user/assigned/addons",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddNewNumberUnansweredMutation,
  useDeleteUnansweredHandlingNumberMutation,
  useGetAssignedAddonsQuery
} = settingsApi;
